// extracted by mini-css-extract-plugin
export default {"bottomMargin":"SurveyEditForm_bottomMargin__n5yXy"};